import { type IPdfBlock } from '@mahawi/eshop-common/dist/src/types';
import React from 'react';

import {
  type IPrivacyContent,
  type IPrivacyPurpose,
  type IPrivacySection,
} from '../../../legal/privacy-content';
import LegalBlock from './legal-block';

export default function PrivacyDocument({
  content,
}: {
  content: IPrivacyContent;
}): React.JSX.Element {
  const { purposeLabels } = content;

  return (
    <>
      <h1>{content.title}</h1>
      <p className="terms--subtitle">{content.subtitle}</p>
      <p className="terms--version">{content.versionLabel}</p>

      {content.sections.map((section: IPrivacySection): React.JSX.Element => (
        <section key={section.id} id={section.id}>
          <h2>{section.heading}</h2>
          {section.blocks.map(
            (block: IPdfBlock, index: number): React.JSX.Element => (
              <LegalBlock key={`block-${index}`} block={block} />
            ),
          )}
          {(section.purposes ?? []).map(
            (purpose: IPrivacyPurpose): React.JSX.Element => (
              <div key={purpose.id} id={purpose.id} className="terms--purpose">
                <h3>{purpose.title}</h3>
                <dl>
                  <dt>{purposeLabels.data}</dt>
                  <dd>{purpose.data}</dd>
                  <dt>{purposeLabels.legalBasis}</dt>
                  <dd>{purpose.legalBasis}</dd>
                  <dt>{purposeLabels.retention}</dt>
                  <dd>{purpose.retention}</dd>
                </dl>
              </div>
            ),
          )}
        </section>
      ))}
    </>
  );
}
